import React from "react";
import { isZh } from "../../utils/language";

export default function PreRegTable({
  data,
  loading,
  canWrite,
}) {

  function getName(item) {
    if (item.personType === "Internal") {
      return item?.umat?.fullName || "-";
    }

    if (item.personType === "External") {
      return item?.external_person?.name || "-";
    }

    return item?.nonUmatName || "-";
  }

  function getPhone(item) {
    if (item.personType === "Internal") {
      return item?.umat?.phoneNo || "-";
    }

    if (item.personType === "External") {
      return item?.external_person?.phoneNo || "-";
    }

    return item?.nonUmatPhoneNo || "-";
  }

  return (
    <div className="prereg-table">

      <div className="prereg-table-head">
        <div>No</div>
        <div>{isZh() ? "姓名" : "Nama"}</div>
        <div>{isZh() ? "活動" : "Kegiatan"}</div>
        <div>{isZh() ? "電話" : "No. Telp"}</div>
        <div>{isZh() ? "操作" : "Aksi"}</div>
      </div>

      {loading && (
        <div className="prereg-empty">Loading...</div>
      )}

      {!loading &&
        data.map((item, idx) => (
          <div
            key={item.documentId || item.id}
            className="prereg-row"
          >

            <div>{idx + 1}</div>

            <div className="name-cell">
              <div className="main">
                {getName(item)}
              </div>

              <div className="sub">
                {item?.agenda?.subject || "-"}
              </div>
            </div>

            <div>
              {item?.agenda?.subject || "-"}
            </div>

            <div>{getPhone(item)}</div>

            <div className="actions">
              <button className="icon-btn">👁</button>

              {canWrite && (
                <button className="icon-btn">✎</button>
              )}
            </div>

          </div>
        ))}
    </div>
  );
}